/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Assigned_OptionInputs */



/**
* | output |
* | --- |
* | "*Assigned Speaker*" |
*
* @param {Insert_Speaker_Assigned_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_assigned_option = /** @type {((inputs?: Insert_Speaker_Assigned_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Assigned_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("*Locuteur assigné*")
	if (locale === "de") return /** @type {LocalizedString} */ ("*Zugewiesener Sprecher*")
	if (locale === "it") return /** @type {LocalizedString} */ ("*Relatore assegnato*")
	if (locale === "ru") return /** @type {LocalizedString} */ ("*Назначенный докладчик*")
	if (locale === "es") return /** @type {LocalizedString} */ ("*Orador asignado*")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("*指定发言人*")
	if (locale === "ja") return /** @type {LocalizedString} */ ("*担当スピーカー*")
	if (locale === "hi") return /** @type {LocalizedString} */ ("*नियुक्त वक्ता*")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("*Palestrante designado*")
	return /** @type {LocalizedString} */ ("*Assigned Speaker*")
});